import { defineComponent } from 'vue'
import { Grid } from 'components/grid'
import Icon from 'components/icon'

export const LockedByTickerTooltip = defineComponent<{}>(() => {
  return () => {
    return (
      <div class="min-w-[16rem]">
        <Grid
          columns="max-content auto"
          class="h-16 p-3 bg-teal-100 justify-start items-start gap-2"
          alignItems="center"
        >
          <div class="w-10 h-10 p-2 bg-teal-500 text-teal-100">
            <Icon
              src={async () => await import('assets/img/svg/icons/chain-link.svg?url')}
              stroke="currentColor"
            />
          </div>
          <Grid noDefaultLayout rows="max-content max-content" alignItems="center">
            <div class="text-teal-500 text-xs font-semibold font-['Inter'] leading-[18px]">
              Findex Integrations
            </div>
            <div class="text-gray-500 text-xs font-normal font-['Inter'] leading-[18px]">
              Asset API
            </div>
          </Grid>
        </Grid>
        <div class="divide-y divide-gray-200">
          <Grid class="p-3 bg-white" rows="max-content" justifyContent="start" alignItems="center">
              <div class="text-gray-900 text-xs font-medium font-['Inter'] leading-3">
                This field is fetched automatically
              </div>
          </Grid>
        </div>
      </div>
    )
  }
})
